// src/components/Routes.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

// Import components
import Home from '../pages/Home';
import Survey from '../pages/Survey';
import Login from '../pages/Login';
import Logout from '../pages/Logout';


function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/survey/:id" element={<Survey />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default AppRoutes;
